import { render, staticRenderFns } from "./ProfileTabBar.vue?vue&type=template&id=2597a88d&scoped=true&"
import script from "./ProfileTabBar.vue?vue&type=script&lang=js&"
export * from "./ProfileTabBar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTabBar.vue?vue&type=style&index=0&id=2597a88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597a88d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VTab,VTabs,VToolbar})
